import React from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    ref?: React.RefObject<HTMLButtonElement>;
}

const TransparentIconButton = ({ children, disabled, className = '', ...rest }: Props) => {
    const baseClasses = 'bg-transparent transition-all p-1 rounded-full';
    const hoverClasses = disabled ? '' : 'hover:bg-secondary-pale';
    const cursorClass = disabled ? 'cursor-not-allowed' : '';

    const combinedClassName = `${baseClasses} ${hoverClasses} ${cursorClass} ${className}`.trim();

    return (
        <button
            {...rest}
            disabled={disabled}
            className={combinedClassName}
        >
            {children}
        </button>
    )
}

export default TransparentIconButton